import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { formatCurrency } from '../../../shared/utils/smartutils';

const BottomBarInfoBalanceSmartPay = (props) => {
  const { t, valueInTransit, currentBalance } = props;

  return (
    <div className="form__form-group--2_columns mt-4 mb-0">
      <div className="form__form-group d-flex">
        <span className="form__form-group-label">
          {t('general.balance-transit')}
        </span>
        <span className="ml-2 text-primary">
          {formatCurrency(valueInTransit)}
        </span>
      </div>
      <div className="form__form-group d-flex mb-2">
        <span className="form__form-group-label">
          {t('general.current-balance')}
        </span>
        <span className="ml-2 text-warning">
          {formatCurrency(currentBalance)}
        </span>
      </div>
    </div>
  );
};

BottomBarInfoBalanceSmartPay.propTypes = {
  t: PropTypes.func.isRequired,
  valueInTransit: PropTypes.string,
  currentBalance: PropTypes.string,
};

BottomBarInfoBalanceSmartPay.defaultProps = {
  valueInTransit: 0,
  currentBalance: 0,
};

export default withTranslation('common')(BottomBarInfoBalanceSmartPay);
